import React from "react";
import { IconProps } from "./IconProps";

const ArrowDown: React.FC<IconProps> = ({
    size = 20,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <path
                d="M12 5V19M12 19L19 12M12 19L5 12"
                stroke={color}
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ArrowDown;
